// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg%20viewBox=%270%200%2016%2016%27%20height=%2716%27%20width=%2716%27%20xmlns=%27http://www.w3.org/2000/svg%27%20xml:space=%27preserve%27%20style=%27fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2%27%3e%3cpath%20d=%27M6.4%2019%205%2017.6l5.6-5.6L5%206.4%206.4%205l5.6%205.6L17.6%205%2019%206.4%2013.4%2012l5.6%205.6-1.4%201.4-5.6-5.6L6.4%2019Z%27%20style=%27fill-rule:nonzero%27%20transform=%27matrix%28.85714%200%200%20.85714%20-2.286%20-2.286%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg%20viewBox=%270%200%2016%2016%27%20height=%2716%27%20width=%2716%27%20xmlns=%27http://www.w3.org/2000/svg%27%20xml:space=%27preserve%27%20style=%27fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2%27%3e%3cpath%20d=%27M6.4%2019%205%2017.6l5.6-5.6L5%206.4%206.4%205l5.6%205.6L17.6%205%2019%206.4%2013.4%2012l5.6%205.6-1.4%201.4-5.6-5.6L6.4%2019Z%27%20style=%27fill:%23fff;fill-rule:nonzero%27%20transform=%27matrix%28.85714%200%200%20.85714%20-2.286%20-2.286%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
.toastify.dialogs {
  min-width: 200px;
  background: none;
  background-color: var(--color-main-background);
  color: var(--color-main-text);
  box-shadow: 0 0 6px 0 var(--color-box-shadow);
  padding: 0 12px;
  margin-top: 45px;
  position: fixed;
  z-index: 10100;
  border-radius: var(--border-radius);
  display: flex;
  align-items: center;
  min-height: 50px;
}
.toastify.dialogs .toast-loader-container,
.toastify.dialogs .toast-undo-container {
  display: flex;
  align-items: center;
  width: 100%;
}
.toastify.dialogs .toast-undo-button,
.toastify.dialogs .toast-close {
  position: static;
  overflow: hidden;
  box-sizing: border-box;
  min-width: 44px;
  height: 100%;
  padding: 12px;
  white-space: nowrap;
  background-repeat: no-repeat;
  background-position: center;
  background-color: transparent;
  min-height: 0;
}
.toastify.dialogs .toast-undo-button.toast-close,
.toastify.dialogs .toast-close.toast-close {
  text-indent: 0;
  opacity: 0.4;
  border: none;
  min-height: 44px;
  margin-left: 10px;
  font-size: 0;
  /* dark theme overrides for Nextcloud 25 and later */
}
.toastify.dialogs .toast-undo-button.toast-close::before,
.toastify.dialogs .toast-close.toast-close::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  content: " ";
  filter: var(--background-invert-if-dark);
  display: inline-block;
  width: 16px;
  height: 16px;
}
.toastify.dialogs .toast-undo-button.toast-undo-button,
.toastify.dialogs .toast-close.toast-undo-button {
  margin: 3px;
  height: calc(100% - 2 * 3px);
  margin-left: 12px;
}
.toastify.dialogs .toast-undo-button:hover, .toastify.dialogs .toast-undo-button:focus, .toastify.dialogs .toast-undo-button:active,
.toastify.dialogs .toast-close:hover,
.toastify.dialogs .toast-close:focus,
.toastify.dialogs .toast-close:active {
  cursor: pointer;
  opacity: 1;
}
.toastify.dialogs.toastify-top {
  right: 10px;
}
.toastify.dialogs.toast-with-click {
  cursor: pointer;
}
.toastify.dialogs.toast-error {
  border-left: 3px solid var(--color-element-error, var(--color-error));
}
.toastify.dialogs.toast-info {
  border-left: 3px solid var(--color-element-info, var(--color-primary));
}
.toastify.dialogs.toast-warning {
  border-left: 3px solid var(--color-element-warning, var(--color-warning));
}
.toastify.dialogs.toast-success {
  border-left: 3px solid var(--color-element-success, var(--color-success));
}
.toastify.dialogs.toast-undo {
  border-left: 3px solid var(--color-element-success, var(--color-success));
}
.toastify.dialogs.toast-loading {
  border-left: 3px solid var(--color-element-info, var(--color-primary));
}
.toastify.dialogs.toast-loading .toast-loader {
  display: inline-block;
  width: 20px;
  height: 20px;
  animation: rotate var(--animation-duration, 0.8s) linear infinite;
  margin-left: auto;
}

/* dark theme overrides for Nextcloud 24 and earlier */
.theme--dark .toastify.dialogs .toast-close {
  /* close icon style */
}
.theme--dark .toastify.dialogs .toast-close.toast-close::before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.nc-generic-dialog .dialog__actions {
	justify-content: space-between;
	min-width: calc(100% - 12px);
}
/*!
 * SPDX-FileCopyrightText: 2023-2024 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * Icon styling of the file list row preview or fallback icon
 * (leading icon on the name row and header)
 */
._file-picker__file-icon_3v9zx_9 {
  position: relative;
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  background-repeat: no-repeat;
  background-size: contain;
  display: flex;
  justify-content: center;
}

._file-picker__file-icon--primary_3v9zx_21 {
  color: var(--color-primary-element);
}

._file-picker__file-icon-overlay_3v9zx_25 {
  color: var(--color-primary-element-text);
  position: absolute;
  inset-block-start: 10px;
}/*!
 * SPDX-FileCopyrightText: 2023-2024 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
tr.file-picker__row[data-v-15187afc] {
  height: var(--row-height, 50px);
}
tr.file-picker__row td[data-v-15187afc] {
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  border-bottom: none;
}
tr.file-picker__row td.row-checkbox[data-v-15187afc] {
  padding: 0 2px;
}
tr.file-picker__row td[data-v-15187afc]:not(.row-checkbox) {
  padding-inline: 14px 0;
}
tr.file-picker__row td.row-size[data-v-15187afc] {
  text-align: end;
  padding-inline: 0 14px;
}
tr.file-picker__row td.row-name[data-v-15187afc] {
  padding-inline: 2px 0;
}
@keyframes gradient-15187afc {
0% {
    background-position: 0% 50%;
}
50% {
    background-position: 100% 50%;
}
100% {
    background-position: 0% 50%;
}
}
.loading-row .row-checkbox[data-v-15187afc] {
  text-align: center !important;
}
.loading-row span[data-v-15187afc] {
  display: inline-block;
  height: 24px;
  background: linear-gradient(to right, var(--color-background-darker), var(--color-text-maxcontrast), var(--color-background-darker));
  background-size: 600px 100%;
  border-radius: var(--border-radius);
  animation: gradient-15187afc 12s ease infinite;
}
.loading-row .row-wrapper[data-v-15187afc] {
  display: inline-flex;
  align-items: center;
}
.loading-row .row-checkbox span[data-v-15187afc] {
  width: 24px;
}
.loading-row .row-name span[data-v-15187afc]:last-of-type {
  margin-inline-start: 6px;
  width: 130px;
}
.loading-row .row-size span[data-v-15187afc] {
  width: 80px;
}
.loading-row .row-modified span[data-v-15187afc] {
  width: 90px;
}/*!
 * SPDX-FileCopyrightText: 2023-2024 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
tr.file-picker__row[data-v-4892c2a0] {
  height: var(--row-height, 50px);
}
tr.file-picker__row td[data-v-4892c2a0] {
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  border-bottom: none;
}
tr.file-picker__row td.row-checkbox[data-v-4892c2a0] {
  padding: 0 2px;
}
tr.file-picker__row td[data-v-4892c2a0]:not(.row-checkbox) {
  padding-inline: 14px 0;
}
tr.file-picker__row td.row-size[data-v-4892c2a0] {
  text-align: end;
  padding-inline: 0 14px;
}
tr.file-picker__row td.row-name[data-v-4892c2a0] {
  padding-inline: 2px 0;
}
.file-picker__row--selected[data-v-4892c2a0] {
  background-color: var(--color-background-dark);
}
.file-picker__row[data-v-4892c2a0]:hover {
  background-color: var(--color-background-hover);
}
.file-picker__name-container[data-v-4892c2a0] {
  display: flex;
  justify-content: start;
  align-items: center;
  height: 100%;
}
.file-picker__file-name[data-v-4892c2a0] {
  padding-inline-start: 6px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.file-picker__file-extension[data-v-4892c2a0] {
  color: var(--color-text-maxcontrast);
  min-width: fit-content;
}.file-picker__header-preview[data-v-4f5d2a56] {
  width: 22px;
  height: 32px;
  flex: 0 0 auto;
}
.file-picker__files[data-v-4f5d2a56] {
  margin: 2px;
  margin-inline-start: 12px;
  overflow: scroll auto;
}
.file-picker__files table[data-v-4f5d2a56] {
  width: 100%;
  max-height: 100%;
  table-layout: fixed;
}
.file-picker__files th[data-v-4f5d2a56] {
  position: sticky;
  z-index: 1;
  top: 0;
  background-color: var(--color-main-background);
  padding: 2px;
}
.file-picker__files th .header-wrapper[data-v-4f5d2a56] {
  display: flex;
}
.file-picker__files th.row-checkbox[data-v-4f5d2a56] {
  width: 44px;
}
.file-picker__files th.row-name[data-v-4f5d2a56] {
  width: 230px;
}
.file-picker__files th.row-size[data-v-4f5d2a56] {
  width: 100px;
}
.file-picker__files th.row-modified[data-v-4f5d2a56] {
  width: 120px;
}
.file-picker__files th[data-v-4f5d2a56]:not(.row-size) .button-vue__wrapper {
  justify-content: start;
  flex-direction: row-reverse;
}
.file-picker__files th[data-v-4f5d2a56]:not(.row-size) .button-vue {
  padding-inline: 16px 4px;
}
.file-picker__files th.row-size[data-v-4f5d2a56] .button-vue__wrapper {
  justify-content: end;
}
.file-picker__files th[data-v-4f5d2a56] .button-vue__wrapper {
  color: var(--color-text-maxcontrast);
}
.file-picker__files th[data-v-4f5d2a56] .button-vue__wrapper .button-vue__text {
  font-weight: normal;
}.file-picker__breadcrumbs[data-v-ec4d392b] {
  flex-grow: 0 !important;
}.file-picker__side[data-v-f5975252] {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.5rem;
  min-width: 200px;
  padding: 2px;
  margin-block-start: 7px;
  overflow: auto;
}
.file-picker__side[data-v-f5975252] .button-vue__wrapper {
  justify-content: start;
}
.file-picker__filter-input[data-v-f5975252] {
  margin-block: 7px;
  max-width: 260px;
}
@media (max-width: 736px) {
.file-picker__side[data-v-f5975252] {
    flex-direction: row;
    min-width: unset;
}
}
@media (max-width: 512px) {
.file-picker__side[data-v-f5975252] {
    flex-direction: row;
    min-width: unset;
}
.file-picker__filter-input[data-v-f5975252] {
    max-width: unset;
}
}/* Ensure focus outline is visible */
.file-picker__navigation {
  padding-inline: 8px 2px;
}
.file-picker__navigation, .file-picker__navigation * {
  box-sizing: border-box;
}
.file-picker__navigation .v-select.select {
  min-width: 220px;
}
@media (min-width: 513px) and (max-width: 736px) {
.file-picker__navigation {
    gap: 11px;
}
}
@media (max-width: 512px) {
.file-picker__navigation {
    flex-direction: column-reverse !important;
}
}.file-picker__view[data-v-552cc2f5] {
  height: 50px;
  display: flex;
  justify-content: start;
  align-items: center;
}
.file-picker__view h3[data-v-552cc2f5] {
  font-weight: bold;
  height: fit-content;
  margin: 0;
}
.file-picker__main[data-v-552cc2f5] {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  flex: 1;
  padding-inline: 2px;
}
.file-picker__main *[data-v-552cc2f5] {
  box-sizing: border-box;
}
[data-v-552cc2f5] .file-picker {
  height: min(80vh, 800px) !important;
}
@media (max-width: 512px) {
[data-v-552cc2f5] .file-picker {
    height: calc(100% - 16px - var(--default-clickable-area)) !important;
}
}
[data-v-552cc2f5] .file-picker__content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}.public-auth-prompt__text[data-v-414f7090] {
  font-size: 1.25em;
  margin-block: 0 calc(3 * var(--default-grid-baseline));
}
.public-auth-prompt__header[data-v-414f7090] {
  margin-block: 0 calc(3 * var(--default-grid-baseline));
}
.public-auth-prompt__header[data-v-414f7090]:first-child {
  margin-top: 0;
}
.public-auth-prompt__input[data-v-414f7090] {
  margin-block: calc(4 * var(--default-grid-baseline)) calc(2 * var(--default-grid-baseline));
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/dialogs/dist/style.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,gBAAgB;EAChB,gBAAgB;EAChB,8CAA8C;EAC9C,6BAA6B;EAC7B,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;AACA;;EAEE,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,aAAa;AACf;AACA;;EAEE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,oDAAoD;AACtD;AACA;;EAEE,yDAAsf;EACtf,YAAY;EACZ,wCAAwC;EACxC,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;AACA;;EAEE,WAAW;EACX,4BAA4B;EAC5B,iBAAiB;AACnB;AACA;;;;EAIE,eAAe;EACf,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,qEAAqE;AACvE;AACA;EACE,sEAAsE;AACxE;AACA;EACE,yEAAyE;AAC3E;AACA;EACE,yEAAyE;AAC3E;AACA;EACE,yEAAyE;AAC3E;AACA;EACE,sEAAsE;AACxE;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iEAAiE;EACjE,iBAAiB;AACnB;;AAEA,sDAAsD;AACtD;EACE,qBAAqB;AACvB;AACA;EACE,yDAAkgB;AACpgB;AACA;CACC,8BAA8B;CAC9B,4BAA4B;AAC7B;AACA;;;EAGE;AACF;;;EAGE;AACF;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;EACxB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,uBAAuB;AACzB,CAAC;;;EAGC;AACF;EACE,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,6BAA6B;AACjC;AACA;IACI,2BAA2B;AAC/B;AACA;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,oIAAoI;EACpI,2BAA2B;EAC3B,mCAAmC;EACnC,8CAA8C;AAChD;AACA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb,CAAC;;;EAGC;AACF;EACE,+BAA+B;AACjC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,8CAA8C;AAChD;AACA;EACE,+CAA+C;AACjD;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,sBAAsB;AACxB,CAAC;EACC,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,MAAM;EACN,8CAA8C;EAC9C,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,mBAAmB;AACrB,CAAC;EACC,uBAAuB;AACzB,CAAC;EACC,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;AACA;AACA;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA,CAAC,oCAAoC;AACrC;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;AACA;IACI,SAAS;AACb;AACA;AACA;AACA;IACI,yCAAyC;AAC7C;AACA,CAAC;EACC,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,OAAO;EACP,mBAAmB;AACrB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mCAAmC;AACrC;AACA;AACA;IACI,oEAAoE;AACxE;AACA;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB,CAAC;EACC,iBAAiB;EACjB,sDAAsD;AACxD;AACA;EACE,sDAAsD;AACxD;AACA;EACE,aAAa;AACf;AACA;EACE,2FAA2F;AAC7F","sourcesContent":["/*!\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n.toastify.dialogs {\n  min-width: 200px;\n  background: none;\n  background-color: var(--color-main-background);\n  color: var(--color-main-text);\n  box-shadow: 0 0 6px 0 var(--color-box-shadow);\n  padding: 0 12px;\n  margin-top: 45px;\n  position: fixed;\n  z-index: 10100;\n  border-radius: var(--border-radius);\n  display: flex;\n  align-items: center;\n  min-height: 50px;\n}\n.toastify.dialogs .toast-loader-container,\n.toastify.dialogs .toast-undo-container {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n.toastify.dialogs .toast-undo-button,\n.toastify.dialogs .toast-close {\n  position: static;\n  overflow: hidden;\n  box-sizing: border-box;\n  min-width: 44px;\n  height: 100%;\n  padding: 12px;\n  white-space: nowrap;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-color: transparent;\n  min-height: 0;\n}\n.toastify.dialogs .toast-undo-button.toast-close,\n.toastify.dialogs .toast-close.toast-close {\n  text-indent: 0;\n  opacity: 0.4;\n  border: none;\n  min-height: 44px;\n  margin-left: 10px;\n  font-size: 0;\n  /* dark theme overrides for Nextcloud 25 and later */\n}\n.toastify.dialogs .toast-undo-button.toast-close::before,\n.toastify.dialogs .toast-close.toast-close::before {\n  background-image: url(\"data:image/svg+xml,%3csvg%20viewBox='0%200%2016%2016'%20height='16'%20width='16'%20xmlns='http://www.w3.org/2000/svg'%20xml:space='preserve'%20style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2'%3e%3cpath%20d='M6.4%2019%205%2017.6l5.6-5.6L5%206.4%206.4%205l5.6%205.6L17.6%205%2019%206.4%2013.4%2012l5.6%205.6-1.4%201.4-5.6-5.6L6.4%2019Z'%20style='fill-rule:nonzero'%20transform='matrix(.85714%200%200%20.85714%20-2.286%20-2.286)'/%3e%3c/svg%3e\");\n  content: \" \";\n  filter: var(--background-invert-if-dark);\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n}\n.toastify.dialogs .toast-undo-button.toast-undo-button,\n.toastify.dialogs .toast-close.toast-undo-button {\n  margin: 3px;\n  height: calc(100% - 2 * 3px);\n  margin-left: 12px;\n}\n.toastify.dialogs .toast-undo-button:hover, .toastify.dialogs .toast-undo-button:focus, .toastify.dialogs .toast-undo-button:active,\n.toastify.dialogs .toast-close:hover,\n.toastify.dialogs .toast-close:focus,\n.toastify.dialogs .toast-close:active {\n  cursor: pointer;\n  opacity: 1;\n}\n.toastify.dialogs.toastify-top {\n  right: 10px;\n}\n.toastify.dialogs.toast-with-click {\n  cursor: pointer;\n}\n.toastify.dialogs.toast-error {\n  border-left: 3px solid var(--color-element-error, var(--color-error));\n}\n.toastify.dialogs.toast-info {\n  border-left: 3px solid var(--color-element-info, var(--color-primary));\n}\n.toastify.dialogs.toast-warning {\n  border-left: 3px solid var(--color-element-warning, var(--color-warning));\n}\n.toastify.dialogs.toast-success {\n  border-left: 3px solid var(--color-element-success, var(--color-success));\n}\n.toastify.dialogs.toast-undo {\n  border-left: 3px solid var(--color-element-success, var(--color-success));\n}\n.toastify.dialogs.toast-loading {\n  border-left: 3px solid var(--color-element-info, var(--color-primary));\n}\n.toastify.dialogs.toast-loading .toast-loader {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  animation: rotate var(--animation-duration, 0.8s) linear infinite;\n  margin-left: auto;\n}\n\n/* dark theme overrides for Nextcloud 24 and earlier */\n.theme--dark .toastify.dialogs .toast-close {\n  /* close icon style */\n}\n.theme--dark .toastify.dialogs .toast-close.toast-close::before {\n  background-image: url(\"data:image/svg+xml,%3csvg%20viewBox='0%200%2016%2016'%20height='16'%20width='16'%20xmlns='http://www.w3.org/2000/svg'%20xml:space='preserve'%20style='fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2'%3e%3cpath%20d='M6.4%2019%205%2017.6l5.6-5.6L5%206.4%206.4%205l5.6%205.6L17.6%205%2019%206.4%2013.4%2012l5.6%205.6-1.4%201.4-5.6-5.6L6.4%2019Z'%20style='fill:%23fff;fill-rule:nonzero'%20transform='matrix(.85714%200%200%20.85714%20-2.286%20-2.286)'/%3e%3c/svg%3e\");\n}\n.nc-generic-dialog .dialog__actions {\n\tjustify-content: space-between;\n\tmin-width: calc(100% - 12px);\n}\n/*!\n * SPDX-FileCopyrightText: 2023-2024 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * Icon styling of the file list row preview or fallback icon\n * (leading icon on the name row and header)\n */\n._file-picker__file-icon_3v9zx_9 {\n  position: relative;\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  min-height: 32px;\n  background-repeat: no-repeat;\n  background-size: contain;\n  display: flex;\n  justify-content: center;\n}\n\n._file-picker__file-icon--primary_3v9zx_21 {\n  color: var(--color-primary-element);\n}\n\n._file-picker__file-icon-overlay_3v9zx_25 {\n  color: var(--color-primary-element-text);\n  position: absolute;\n  inset-block-start: 10px;\n}/*!\n * SPDX-FileCopyrightText: 2023-2024 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\ntr.file-picker__row[data-v-15187afc] {\n  height: var(--row-height, 50px);\n}\ntr.file-picker__row td[data-v-15187afc] {\n  cursor: pointer;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  border-bottom: none;\n}\ntr.file-picker__row td.row-checkbox[data-v-15187afc] {\n  padding: 0 2px;\n}\ntr.file-picker__row td[data-v-15187afc]:not(.row-checkbox) {\n  padding-inline: 14px 0;\n}\ntr.file-picker__row td.row-size[data-v-15187afc] {\n  text-align: end;\n  padding-inline: 0 14px;\n}\ntr.file-picker__row td.row-name[data-v-15187afc] {\n  padding-inline: 2px 0;\n}\n@keyframes gradient-15187afc {\n0% {\n    background-position: 0% 50%;\n}\n50% {\n    background-position: 100% 50%;\n}\n100% {\n    background-position: 0% 50%;\n}\n}\n.loading-row .row-checkbox[data-v-15187afc] {\n  text-align: center !important;\n}\n.loading-row span[data-v-15187afc] {\n  display: inline-block;\n  height: 24px;\n  background: linear-gradient(to right, var(--color-background-darker), var(--color-text-maxcontrast), var(--color-background-darker));\n  background-size: 600px 100%;\n  border-radius: var(--border-radius);\n  animation: gradient-15187afc 12s ease infinite;\n}\n.loading-row .row-wrapper[data-v-15187afc] {\n  display: inline-flex;\n  align-items: center;\n}\n.loading-row .row-checkbox span[data-v-15187afc] {\n  width: 24px;\n}\n.loading-row .row-name span[data-v-15187afc]:last-of-type {\n  margin-inline-start: 6px;\n  width: 130px;\n}\n.loading-row .row-size span[data-v-15187afc] {\n  width: 80px;\n}\n.loading-row .row-modified span[data-v-15187afc] {\n  width: 90px;\n}/*!\n * SPDX-FileCopyrightText: 2023-2024 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\ntr.file-picker__row[data-v-4892c2a0] {\n  height: var(--row-height, 50px);\n}\ntr.file-picker__row td[data-v-4892c2a0] {\n  cursor: pointer;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  border-bottom: none;\n}\ntr.file-picker__row td.row-checkbox[data-v-4892c2a0] {\n  padding: 0 2px;\n}\ntr.file-picker__row td[data-v-4892c2a0]:not(.row-checkbox) {\n  padding-inline: 14px 0;\n}\ntr.file-picker__row td.row-size[data-v-4892c2a0] {\n  text-align: end;\n  padding-inline: 0 14px;\n}\ntr.file-picker__row td.row-name[data-v-4892c2a0] {\n  padding-inline: 2px 0;\n}\n.file-picker__row--selected[data-v-4892c2a0] {\n  background-color: var(--color-background-dark);\n}\n.file-picker__row[data-v-4892c2a0]:hover {\n  background-color: var(--color-background-hover);\n}\n.file-picker__name-container[data-v-4892c2a0] {\n  display: flex;\n  justify-content: start;\n  align-items: center;\n  height: 100%;\n}\n.file-picker__file-name[data-v-4892c2a0] {\n  padding-inline-start: 6px;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.file-picker__file-extension[data-v-4892c2a0] {\n  color: var(--color-text-maxcontrast);\n  min-width: fit-content;\n}.file-picker__header-preview[data-v-4f5d2a56] {\n  width: 22px;\n  height: 32px;\n  flex: 0 0 auto;\n}\n.file-picker__files[data-v-4f5d2a56] {\n  margin: 2px;\n  margin-inline-start: 12px;\n  overflow: scroll auto;\n}\n.file-picker__files table[data-v-4f5d2a56] {\n  width: 100%;\n  max-height: 100%;\n  table-layout: fixed;\n}\n.file-picker__files th[data-v-4f5d2a56] {\n  position: sticky;\n  z-index: 1;\n  top: 0;\n  background-color: var(--color-main-background);\n  padding: 2px;\n}\n.file-picker__files th .header-wrapper[data-v-4f5d2a56] {\n  display: flex;\n}\n.file-picker__files th.row-checkbox[data-v-4f5d2a56] {\n  width: 44px;\n}\n.file-picker__files th.row-name[data-v-4f5d2a56] {\n  width: 230px;\n}\n.file-picker__files th.row-size[data-v-4f5d2a56] {\n  width: 100px;\n}\n.file-picker__files th.row-modified[data-v-4f5d2a56] {\n  width: 120px;\n}\n.file-picker__files th[data-v-4f5d2a56]:not(.row-size) .button-vue__wrapper {\n  justify-content: start;\n  flex-direction: row-reverse;\n}\n.file-picker__files th[data-v-4f5d2a56]:not(.row-size) .button-vue {\n  padding-inline: 16px 4px;\n}\n.file-picker__files th.row-size[data-v-4f5d2a56] .button-vue__wrapper {\n  justify-content: end;\n}\n.file-picker__files th[data-v-4f5d2a56] .button-vue__wrapper {\n  color: var(--color-text-maxcontrast);\n}\n.file-picker__files th[data-v-4f5d2a56] .button-vue__wrapper .button-vue__text {\n  font-weight: normal;\n}.file-picker__breadcrumbs[data-v-ec4d392b] {\n  flex-grow: 0 !important;\n}.file-picker__side[data-v-f5975252] {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.5rem;\n  min-width: 200px;\n  padding: 2px;\n  margin-block-start: 7px;\n  overflow: auto;\n}\n.file-picker__side[data-v-f5975252] .button-vue__wrapper {\n  justify-content: start;\n}\n.file-picker__filter-input[data-v-f5975252] {\n  margin-block: 7px;\n  max-width: 260px;\n}\n@media (max-width: 736px) {\n.file-picker__side[data-v-f5975252] {\n    flex-direction: row;\n    min-width: unset;\n}\n}\n@media (max-width: 512px) {\n.file-picker__side[data-v-f5975252] {\n    flex-direction: row;\n    min-width: unset;\n}\n.file-picker__filter-input[data-v-f5975252] {\n    max-width: unset;\n}\n}/* Ensure focus outline is visible */\n.file-picker__navigation {\n  padding-inline: 8px 2px;\n}\n.file-picker__navigation, .file-picker__navigation * {\n  box-sizing: border-box;\n}\n.file-picker__navigation .v-select.select {\n  min-width: 220px;\n}\n@media (min-width: 513px) and (max-width: 736px) {\n.file-picker__navigation {\n    gap: 11px;\n}\n}\n@media (max-width: 512px) {\n.file-picker__navigation {\n    flex-direction: column-reverse !important;\n}\n}.file-picker__view[data-v-552cc2f5] {\n  height: 50px;\n  display: flex;\n  justify-content: start;\n  align-items: center;\n}\n.file-picker__view h3[data-v-552cc2f5] {\n  font-weight: bold;\n  height: fit-content;\n  margin: 0;\n}\n.file-picker__main[data-v-552cc2f5] {\n  box-sizing: border-box;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  flex: 1;\n  padding-inline: 2px;\n}\n.file-picker__main *[data-v-552cc2f5] {\n  box-sizing: border-box;\n}\n[data-v-552cc2f5] .file-picker {\n  height: min(80vh, 800px) !important;\n}\n@media (max-width: 512px) {\n[data-v-552cc2f5] .file-picker {\n    height: calc(100% - 16px - var(--default-clickable-area)) !important;\n}\n}\n[data-v-552cc2f5] .file-picker__content {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}.public-auth-prompt__text[data-v-414f7090] {\n  font-size: 1.25em;\n  margin-block: 0 calc(3 * var(--default-grid-baseline));\n}\n.public-auth-prompt__header[data-v-414f7090] {\n  margin-block: 0 calc(3 * var(--default-grid-baseline));\n}\n.public-auth-prompt__header[data-v-414f7090]:first-child {\n  margin-top: 0;\n}\n.public-auth-prompt__input[data-v-414f7090] {\n  margin-block: calc(4 * var(--default-grid-baseline)) calc(2 * var(--default-grid-baseline));\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
